'use strict';
import './structure/adjustVh';
import './structure/adjustViewport';
import Rellax from 'rellax';
import InViewEvent from './components/inViewEvent';

document.addEventListener('DOMContentLoaded', () => {
  // console.log('Hello SHIP');
  const inViewEvent = new InViewEvent();
  const rellax = new Rellax('.rellax', {
    breakpoints: [375, 768, 1200],
    horizontal: true,
    // round: true,
  });

  // const rellaxOne = new Rellax('.rellaxBG', {
  //   relativeToWrapper: true,
  //   breakpoints: [375, 700, 1200],
  //   wrapper: '.p_shipKV',
  //   // round: true,
  // });

  // window.addEventListener('scroll', function () {
  //   rellaxOne.refresh();
  // });

  const targetFactor = 0.25;
  const windowHeight = Math.min(window.innerHeight, document.documentElement.clientHeight);

  const parallax = document.getElementsByClassName('rellaxBG');
  const targets = Array.prototype.slice.call(parallax);
  const shipKVseagulls = document.querySelectorAll('.shipKVseagull');
  window.addEventListener('scroll', () => {
    const winW = window.innerWidth;
    const scrollY = Math.max(window.pageYOffset, document.documentElement.scrollTop);
    const targetOffsetTop = document.querySelector('.p_shipKV').offsetTop;
    const scrollYStart = targetOffsetTop - windowHeight;
    const seeep = winW > 768 ? 0.08 : 0.001;
    const seeep2 = winW > 768 ? 0.1 : 0.05;
    const seeep3 = winW > 768 ? 0.15 : 0.07;
    targets[0].style.transform =
      scrollY > scrollYStart
        ? 'translate3d(0,' + `${(scrollY - targetOffsetTop) * seeep3}px` + ',0)'
        : 'translate3d(0,0,0)';
    targets[1].style.transform =
      scrollY > scrollYStart
        ? 'translate3d(0,' + `${(scrollY - targetOffsetTop) * seeep2}px` + ',0)'
        : 'translate3d(0,0,0)';
    // targets[2].style.transform =
    //   scrollY > scrollYStart
    //     ? 'translate3d(0,' + `-${(scrollY - targetOffsetTop) * 0.001}px` + ',0)'
    //     : 'translate3d(0,0,0)';
    targets[2].style.transform =
      scrollY > scrollYStart
        ? 'translate3d(0,' + `-${(scrollY - targetOffsetTop) * seeep}px` + ',0)'
        : 'translate3d(0,0,0)';

    shipKVseagulls[0].style.transform =
      scrollY > scrollYStart
        ? 'translate3d(0,' + `-${(scrollY - targetOffsetTop) * 0.03}px` + ',0)'
        : 'translate3d(0,0,0)';
    shipKVseagulls[1].style.transform =
      scrollY > scrollYStart
        ? 'translate3d(0,' + `-${(scrollY - targetOffsetTop) * 0.07}px` + ',0)'
        : 'translate3d(0,0,0)';
    shipKVseagulls[2].style.transform =
      scrollY > scrollYStart
        ? 'translate3d(0,' + `-${(scrollY - targetOffsetTop) * 0.03}px` + ',0)'
        : 'translate3d(0,0,0)';
    // for (const target of targets) {
    //   const targetOffsetTop = document.querySelector('.p_shipKV').offsetTop;

    //   target.style.transform =
    //     scrollY > scrollYStart
    //       ? 'translate3d(0,' + `-${(scrollY - targetOffsetTop) * targetFactor}px` + ',0)'
    //       : 'translate3d(0,0,0)';
    // }
  });

  const winW = window.innerWidth;
  const scrollY = Math.max(window.pageYOffset, document.documentElement.scrollTop);
  const targetOffsetTop = document.querySelector('.p_shipKV').offsetTop;
  const scrollYStart = targetOffsetTop - windowHeight;
  const seeep = winW > 768 ? 0.08 : 0.001;
  const seeep2 = winW > 768 ? 0.1 : 0.05;
  const seeep3 = winW > 768 ? 0.15 : 0.07;
  targets[0].style.transform =
    scrollY > scrollYStart
      ? 'translate3d(0,' + `${(scrollY - targetOffsetTop) * seeep3}px` + ',0)'
      : 'translate3d(0,0,0)';
  targets[1].style.transform =
    scrollY > scrollYStart
      ? 'translate3d(0,' + `-${(scrollY - targetOffsetTop) * seeep2}px` + ',0)'
      : 'translate3d(0,0,0)';
  // targets[2].style.transform =
  //   scrollY > scrollYStart
  //     ? 'translate3d(0,' + `-${(scrollY - targetOffsetTop) * 0.001}px` + ',0)'
  //     : 'translate3d(0,0,0)';
  targets[2].style.transform =
    scrollY > scrollYStart
      ? 'translate3d(0,' + `-${(scrollY - targetOffsetTop) * seeep}px` + ',0)'
      : 'translate3d(0,0,0)';

  shipKVseagulls[0].style.transform =
    scrollY > scrollYStart
      ? 'translate3d(0,' + `-${(scrollY - targetOffsetTop) * 0.03}px` + ',0)'
      : 'translate3d(0,0,0)';
  shipKVseagulls[1].style.transform =
    scrollY > scrollYStart
      ? 'translate3d(0,' + `-${(scrollY - targetOffsetTop) * 0.07}px` + ',0)'
      : 'translate3d(0,0,0)';
  shipKVseagulls[2].style.transform =
    scrollY > scrollYStart
      ? 'translate3d(0,' + `-${(scrollY - targetOffsetTop) * 0.03}px` + ',0)'
      : 'translate3d(0,0,0)';

  let cylinderX = 0;
  let cylinderY = 0;
  const kvImages = document.querySelectorAll('.p_shipKVSceneImage');
  document.body.addEventListener('mousemove', function (e) {
    cylinderX = (e.clientX / window.innerWidth) * 2 - 1;
    cylinderY = (e.clientY / window.innerHeight) * 2 - 1;

    kvImages[0].style.transform = 'translate(' + cylinderX * 0.1 + '%, ' + cylinderY * 0.2 + '%)';
    kvImages[1].style.transform = 'translate(' + cylinderX * 0.1 + '%, ' + cylinderY * 0.2 + '%)';
    kvImages[2].style.transform = 'translate(' + cylinderX * 0.1 + '%, ' + cylinderY * 0.2 + '%)';
  });

  const logos = document.querySelectorAll('.p_shipProjectOne__logo');
  let prevLogo = null;
  let nextLogo = null;
  let index = 0;
  let logoLeng = logos.length;

  setInterval(() => {
    if (index === 0) {
      nextLogo = logos[index];
      nextLogo.classList.add('Act');
      if (prevLogo) {
        prevLogo = logos[logoLeng - 1];
        prevLogo.classList.remove('Act');
        prevLogo.classList.add('Hide');
        setTimeout(() => {
          prevLogo.classList.remove('Hide');
        }, 1000);
      }
    } else {
      nextLogo = logos[index];
      prevLogo = logos[index - 1];
      nextLogo.classList.add('Act');
      prevLogo.classList.remove('Act');
      prevLogo.classList.add('Hide');
      setTimeout(() => {
        prevLogo.classList.remove('Hide');
      }, 1000);
    }

    index++;

    if (index >= logoLeng) {
      index = 0;
    }
  }, 1700);
});
